/* eslint-disable no-console, camelcase */
const getElementByDripName = (name, form) => (
  form.querySelectorAll(`[data-drip="${name}"]`)
);

const getMultipleValsByDripField = (name, form) => {
  const elements = getElementByDripName(name, form);
  let s = '';
  for (let i = 0; i < elements.length; i++) { /* eslint-disable-line no-plusplus */
    if (elements[i].checked) {
      s += `${elements[i].value},`;
    }
  }
  if (s.lastIndexOf(',') !== -1) {
    s = s.substr(0, s.lastIndexOf(','));
  }
  return s;
};

const getCheckedByDripField = (name, form) => {
  const elements = getElementByDripName(name, form);
  if (elements.length === 1) {
    return elements[0].checked;
  }
  return false;
};

const getValByDripField = (name, form) => {
  const elements = getElementByDripName(name, form);
  if (elements.length === 1) {
    return elements[0].value;
  } else if (elements.length > 1) {
    let s = '';
    for (let i = 0; i < elements.length; i++) { /* eslint-disable-line no-plusplus */
      s += `${elements[i].value},`;
    }
    return s;
  }
  return '';
};

const sendContactDealerLeadToDrip = (form, options) => {
  let tags = [];
  if (getValByDripField('drip_tags', form) !== '') {
    tags = getValByDripField('drip_tags', form).split(',');
  }
  // Trim whitespace
  for (let i = 0; i <= tags.length; i++) { /* eslint-disable-line no-plusplus */
    if (tags[i]) {
      tags[i].trim();
    }
  }
  // Add Opted In tag
  if (getCheckedByDripField('interest_brand', form)) {
    tags.push('Opted In');
  }
  // Switch visualization campaigns
  let campaign = getValByDripField('campaign', form);
  if (getMultipleValsByDripField('viz_key', form) !== '') {
    campaign = getValByDripField('campaign_with_visualization', form);
  }
  /* // Interests
  let interests = '';
  const interestInputValues = getMultipleValsByDripField('product_interests');
  if (interestInputValues != '') {
    interests = interestInputValues;
  } */
  const currentDate = new Date();
  const { _dcq } = window;
  // Drip Call
  _dcq.push([
    'identify',
    {
      email: getValByDripField('email', form),
      first_name: getValByDripField('first_name', form),
      last_name: getValByDripField('last_name', form),
      phone: getValByDripField('phone', form),
      zip: getValByDripField('zip', form),
      source: getValByDripField('source', form),
      d_opt_in: currentDate,
      viz_key: getMultipleValsByDripField('viz_key', form),
      campaign,
      page_submitted_from: window.location.href,
      tags,
      last_form_submitted_date: currentDate,
      success: (data) => {
        // console.log(data);
        if (options !== undefined) {
          if (options.success !== undefined) {
            options.success(data);
          }
        }
      },
      failure: (data) => {
        // console.log(data);
        if (options !== undefined) {
          if (options.fail !== undefined) {
            options.fail(data);
          }
        }
      },
    },
  ]);
};

const sendDealerAvailabilityLeadToDrip = (form, options) => {
  let tags = [];
  if (getValByDripField('drip_tags', form) !== '') {
    tags = getValByDripField('drip_tags', form).split(',');
  }
  // Trim whitespace
  for (let i = 0; i <= tags.length; i++) { /* eslint-disable-line no-plusplus */
    if (tags[i]) {
      tags[i].trim();
    }
  }
  const currentDate = new Date();
  const { _dcq } = window;
  // Drip Call
  _dcq.push([
    'identify',
    {
      email: getValByDripField('email', form),
      in_my_area: false,
      zip: getValByDripField('zip', form),
      source: getValByDripField('source', form),
      page_submitted_from: window.location.href,
      last_form_submitted_date: currentDate,
      success: (data) => {
        // console.log(data);
        if (options !== undefined) {
          if (options.success !== undefined) {
            options.success(data);
          }
        }
      },
      failure: (data) => {
        // console.log(data);
        if (options !== undefined) {
          if (options.fail !== undefined) {
            options.fail(data);
          }
        }
      },
    },
  ]);
};

const sendProductLeadToDrip = (form, options) => {
  // console.log('drip-helpers.js, sendProductLeadToDrip');
  let tags = [];
  if (getValByDripField('drip_tags', form) !== '') {
    tags = getValByDripField('drip_tags', form).split(',');
  }
  // Trim whitespace
  for (let i = 0; i <= tags.length; i++) { /* eslint-disable-line no-plusplus */
    if (tags[i]) {
      tags[i].trim();
    }
  }
  // Add Opted In tag
  if (getCheckedByDripField('interest_brand', form)) {
    tags.push('Opted In');
  }
  // Add width and height (if selected) to product_info json string
  const productInfoVal = getValByDripField('product_info', form);
  const productInfo = JSON.parse(productInfoVal);
  // If single product
  if (productInfo.products.length > 0) {
    productInfo.products[0]['window-width'] = getValByDripField('window_width', form);
    productInfo.products[0]['window-height'] = getValByDripField('window_height', form);
    productInfo.products[0]['color-name'] = getValByDripField('color_name', form);
    productInfo.products[0].notes = getValByDripField('notes', form);
  } else {
    // Check for selected products
    const selectedProductsStr = `[${getMultipleValsByDripField('selected_product_info', form)}]`;
    const selectedProducts = JSON.parse(selectedProductsStr);
    productInfo.products = [...selectedProducts];
  }
  // console.log(productInfo);
  const currentDate = new Date();
  const { _dcq } = window;
  // Drip Call
  _dcq.push([
    'identify',
    {
      email: getValByDripField('email', form),
      first_name: getValByDripField('first_name', form),
      last_name: getValByDripField('last_name', form),
      phone: getValByDripField('phone', form),
      zip: getValByDripField('zip', form),
      notes: getValByDripField('notes', form),
      source: getValByDripField('source', form),
      d_opt_in: currentDate,
      product_info: JSON.stringify(productInfo),
      campaign: getValByDripField('campaign', form),
      page_submitted_from: window.location.href,
      tags,
      last_form_submitted_date: currentDate,
      success: (data) => {
        // console.log(data);
        if (options !== undefined) {
          if (options.success !== undefined) {
            options.success(data);
          }
        }
      },
      failure: (data) => {
        // console.log(data);
        if (options !== undefined) {
          if (options.fail !== undefined) {
            options.fail(data);
          }
        }
      },
    },
  ]);
};

const sendSwatchOrderLeadToDrip = (options) => {
  // console.log('drip-helpers.js, sendSwatchOrderLeadToDrip');
  // console.log(options);
  const {
    address1,
    address2,
    city,
    country,
    dealer_optin,
    drip_tags,
    email,
    fail,
    first_name,
    interest_brand,
    last_name,
    page_submitted_from,
    phone,
    source,
    state,
    success,
    zip,
  } = options;
  let tags = [];
  if (drip_tags !== '') {
    tags = drip_tags.split(',');
  }
  // Trim whitespace
  for (let i = 0; i <= tags.length; i++) { /* eslint-disable-line no-plusplus */
    if (tags[i]) {
      tags[i].trim();
    }
  }
  // Add Opted In tag
  if (interest_brand === 'True') {
    tags.push('Opted In');
  }
  // Add date for dealer opt-in
  if (dealer_optin === 'True') {
    tags.push('Consumer Lead to Pickup');
  }
  const currentDate = new Date();
  const { _dcq } = window;
  // Drip Call
  _dcq.push([
    'identify',
    {
      email,
      first_name,
      last_name,
      phone,
      address1,
      address2,
      city,
      state,
      zip,
      country,
      source,
      d_opt_in: currentDate,
      page_submitted_from,
      tags,
      last_form_submitted_date: currentDate,
      success: (data) => {
        // console.log(data);
        if (success !== undefined) {
          success(data);
        }
      },
      failure: (data) => {
        // console.log(data);
        if (fail !== undefined) {
          fail(data);
        }
      },
    },
  ]);
};

export {
  sendContactDealerLeadToDrip,
  sendDealerAvailabilityLeadToDrip,
  sendProductLeadToDrip,
  sendSwatchOrderLeadToDrip,
};
/* eslint-enable no-console, camelcase */
